

const template = document.createElement('template');
template.innerHTML = `
<style>
  :host {
    width: 100%
  }

  .personalisation-dropdown {
    text-align: left;
  }

  .personalisation-dropdown .toggle-button__checkbox:after {
    content: "";
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none'%3E%3Cpath d='M7 1L3 7L1 4.5' stroke='white' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-color: var(--opaque-lark-navy);
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 1.75rem;
    transform: scale(0);
    transition-timing-function: cubic-bezier(.49,.25,.38,.76);
    transition-duration: .2s;
    transition-property: transform;
  } 

  .personalisation-dropdown.is-active .toggle-button__checkbox:after {
    transform: scale(1);
  } 

  .dropdown-content { 
    display: none 
  }

  .personalisation-dropdown.is-active .dropdown-content {
    display: block;
  }

  .toggle-button {
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 1.25rem 0;
    width: 100%;
  }

  .toggle-button__title {
    color: var(--opaque-lark-navy) !important;
    font-family: var(--font-secondary);
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.135rem;
    text-transform: uppercase;
    text-align: left;
  }

  .toggle-button__checkbox {
    background-color: var(--transparent-navy-navy-4);
    border-radius: 1.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
  }
</style>

<div class="personalisation-dropdown" part="navigation">
  <button class="toggle-button">
    <span class="toggle-button__title">{{title}}</span>
    <span class="toggle-button__checkbox">
      
    </span>
  </button>
  <div class="dropdown-content">
    <slot></slot>
  </div>
</div>
`;

export class PersonalisationDropdown extends HTMLElement {


  // Properties
  private readonly root:HTMLDivElement|null;
  private readonly toggleButton:HTMLDivElement|null;
  private readonly toggleButtonTitle:HTMLElement|null;

  constructor() {
    super();

    // Attach shadow root
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    // Query things
    this.root = shadowRoot.querySelector('.personalisation-dropdown')!;
    this.toggleButton = shadowRoot.querySelector('.toggle-button')!;
    this.toggleButtonTitle = shadowRoot.querySelector('.toggle-button__title')!;

    this.toggleButton?.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    const title = this.getAttribute('title');
    this.toggleButtonTitle.textContent = title;
  }

  public get isActive() {
    return this.root?.classList.contains('is-active');
  }

  private handleClick(e) {
    const event = new CustomEvent('dropdown_toggle', { 
      detail: this, 
      bubbles: true, 
      composed: true 
    });
    this.dispatchEvent(event);
}

  public setActive(isActive:boolean) {
    this.root?.classList[isActive ? 'add' : 'remove']('is-active');
  }

}

if(!customElements.get('personalisation-dropdown')) {
  customElements.define('personalisation-dropdown', PersonalisationDropdown);
}